import "./colorbox.scss"
require("jquery-colorbox/jquery.colorbox")
